import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {
    Button,
    Input,
    Table,
    TableColumn,
    Dialog,
    Card,
    Container,
    Icon,
    Select,
    Form,
    Tag,
    Tree,
    Pagination,
    Badge,
    Loading,
    Message,
    MessageBox,
    Menu,
    Tabs,
    TabPane,
    Breadcrumb,
    BreadcrumbItem,
    Dropdown,
    Steps,
    Tooltip,
    Popover,
    Collapse,
    FormItem,
    Checkbox,
    Header,
    DropdownMenu,
    DropdownItem,
    Aside,
    Main,
    MenuItem,
    Submenu,
    Option,
    Col,
    Row,
    Upload,
    Radio,
    DatePicker,
    RadioGroup,
    CollapseItem,
    Switch,
    Transfer,
    InputNumber,
    Timeline,
    TimelineItem,
    Carousel,
    CarouselItem,
    Image
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import echarts from 'echarts'

Vue.prototype.$ELEMENT = {size: 'small', zIndex: 3000};
Vue.use(Switch);
Vue.use(CollapseItem);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(DatePicker);
Vue.use(Upload);
Vue.use(Row);
Vue.use(Col);
Vue.use(Option);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(Header);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Checkbox);
Vue.use(FormItem);
Vue.use(Collapse);
Vue.use(Popover);
Vue.use(Menu);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Dropdown);
Vue.use(Steps);
Vue.use(Tooltip);
Vue.use(Tree);
Vue.use(Pagination);
Vue.use(Badge);
Vue.use(Loading);
Vue.use(Button);
Vue.use(Input);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Dialog);
Vue.use(Card);
Vue.use(Container);
Vue.use(Icon);
Vue.use(Select);
Vue.use(Form);
Vue.use(Tag);
Vue.use(Transfer);
Vue.use(InputNumber);
Vue.component(Message);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Image);
Vue.use(echarts);
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$message = Message;
Vue.prototype.$echarts = echarts;

import {
    Button as VanButton,
    Form as VanForm,
    Field as VanField,
    Loading as VanLoading,
    Notify as VanNotify,
    Col as VanCol,
    Row as VanRow,
    Overlay as VanOverlay,
    Cell as VanCell,
    CellGroup as VanCellGroup,
    Divider as VanDivider,
    Icon as VanIcon,
    RadioGroup as VanRadioGroup,
    Radio as VanRadio,
    Popup as VanPopup,
    TabbarItem as VanTabbarItem,
    Tabbar as VanTabbar,
    Empty as VanEmpty,
    Image as VanImage,
    Tabs as VanTabs,
    Tab as VanTab,
    List as VanList,
    PullRefresh as VanPullRefresh,
    Tag as VanTag,
    Lazyload as VanLazyload,
    Picker as VanPicker,
    Step as VanStep,
    Steps as VanSteps
} from 'vant';
import 'vant/lib/index.css';
import 'vant/lib/icon/local.css';

Vue.use(VanButton);
Vue.use(VanForm);
Vue.use(VanField);
Vue.use(VanLoading);
Vue.use(VanNotify);
Vue.use(VanCol);
Vue.use(VanRow);
Vue.use(VanOverlay);
Vue.use(VanCell);
Vue.use(VanCellGroup);
Vue.use(VanDivider);
Vue.use(VanIcon);
Vue.use(VanRadioGroup);
Vue.use(VanRadio);
Vue.use(VanPopup);
Vue.use(VanTabbarItem);
Vue.use(VanTabbar);
Vue.use(VanEmpty);
Vue.use(VanImage);
Vue.use(VanTabs);
Vue.use(VanTab);
Vue.use(VanList);
Vue.use(VanPullRefresh);
Vue.use(VanTag);
Vue.use(VanLazyload);
Vue.use(VanPicker);
Vue.use(VanStep);
Vue.use(VanSteps);

import {postRequest} from "./utils/api";
import {postKeyValueRequest} from "./utils/api";
import {putRequest} from "./utils/api";
import {deleteRequest} from "./utils/api";
import {getRequest} from "./utils/api";
import {getViewRequest} from "./utils/api";
import {getIpRequest} from "./utils/api";
import {baseUrl} from "./utils/api";
import {initMenu} from "./utils/menus";
import 'font-awesome/css/font-awesome.min.css'

Vue.prototype.postRequest = postRequest;
Vue.prototype.postKeyValueRequest = postKeyValueRequest;
Vue.prototype.putRequest = putRequest;
Vue.prototype.deleteRequest = deleteRequest;
Vue.prototype.getRequest = getRequest;
Vue.prototype.getViewRequest = getViewRequest;
Vue.prototype.getIpRequest = getIpRequest;
Vue.prototype.baseUrl = baseUrl;

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
    if (to.meta.requireAuth) {
        if (store.state.user.username) {
            next()
        } else {
            next({
                path: 'login',
                query: {redirect: to.fullPath}
            })
        }
    } else {
        next()
    }
})

router.afterEach(() => {window.scrollTo(0,0);
    }
)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
